<!-- src/app/pages/dashboard/components/stat-card/stat-card.component.html -->
<div class="flex flex-col gap-4">
    <div class="">
        <div class="yearWrap">
            <div class="simSlide">
                <p>
                    Selected Simulation:
                    <span>{{ selectedSimulation$ | async }}</span>
                </p>
            </div>
        </div>
        <div class="statCard grid gap-2 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
            @if (displayCards.length === 0) {
                @for (i of [1, 2, 3, 4]; track i) {
                    <div class="relative bg-white p-4 rounded-2xl shadow-sm">
                        <div class="flex items-start gap-2">
                            <div class="h-10 w-10 rounded-xl bg-slate-100" style="animation: pulse 1.2s ease-in-out infinite"></div>
                            <div class="flex-1">
                                <div class="h-3 w-40 bg-slate-200 rounded mb-3" style="animation: pulse 1.2s ease-in-out infinite"></div>
                                <div class="h-4 w-20 bg-slate-200 rounded" style="animation: pulse 1.2s ease-in-out infinite"></div>
                                <div class="h-3 w-32 bg-slate-200 rounded mt-2" style="animation: pulse 1.2s ease-in-out infinite"></div>
                            </div>
                        </div>
                    </div>
                }
            } @else {
                @if (displayCards; as items) {
                    @for (c of items; track trackById($index, c)) {
                        <div class="relative bg-white p-2 rounded-2xl shadow-sm border border-slate-200/60">
                            <div class="flex items-start gap-2" [pTooltip]="c.tooltipTitle" [tooltipDisabled]="!c.tooltipTitle" tooltipPosition="top">
                                <div class="h-10 w-10 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center text-slate-500">
                                    <img [src]="iconSrc(c.id)" [alt]="c.title" style="width: 18px; height: 18px; object-fit: contain" />
                                </div>
                                <div class="flex-1 min-w-0">
                                    <div class="text-slate-600 text-sm font-medium truncate">{{ c.title }}</div>
                                    <div class="flex items-baseline gap-3">
                                        <div class="text-lg font-extrabold text-slate-800 valuePerc">{{ c.percent | number: '1.0-0' }}%</div>
                                        <div class="text-sm font-semibold text-slate-500 valueTxt">
                                            {{ formatNumber(c.value) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                }
            }
        </div>
    </div>
</div>

<style>
    @keyframes pulse {
        0% {
            opacity: 0.6;
        }

        50% {
            opacity: 1;
        }

        100% {
            opacity: 0.6;
        }
    }
</style>
